import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ClientService } from "../../../../../../services/clientService";
import NotificationManager from "react-notifications/lib/NotificationManager";
import APP_ROUTES from "src/helper/app-routes";
import RecentIssue from "./recent-issues";
import Interference from "./cats-interference";
import { useLocation } from "react-router";
// import InputKendoRct from "../../../control-components/input/input";
import InputKendoRct from "src/control-components/input/input";
import { renderErrors } from "src/helper/error-message-helper";
import ClientQuestionnaireService from "./functionToSaveQuestionnaireFromPortal";

const CSSRS = ({
  list,
  questionId,
  subList,
  interfered,
  response,
  isPrint,
  isFromCP,
  token,
   queId
}) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const selectedClientId = useSelector((state) => state.selectedClientId);
  const [loading, setLoading] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [listItems, setListItems] = useState(list);

  const [fields, setFields] = useState({
    event: "",
    brother: "",
  });

  const totalSum = listItems.reduce(
    (sum, item) => sum + (Number(item.value) || 0),
    0
  );

  useEffect(() => {
    const l1 = listItems.map((item) => {
      const foundItem = response.find((i) => i.questionId === item.questionId);
      if (foundItem) {
        if (item.type === "question") {
          const [firstValue] = foundItem.value ? foundItem.value.split(",").map(v => v.trim()) : [null];
            return {
              ...item,
              isSelected: firstValue === "true" ? true : firstValue === "false" ? false : null,
              value: foundItem.value || "null,",
            };
          }
        return { ...item, ...foundItem };
      } else {
        return item;
      }
    });

    setTimeout(() => {
      setListItems(l1);
    }, 0);
  }, [response]);

  const handleRadioChange = (itemId, value) => {
    const updatedItems = listItems.map((item) => {
      if (item.questionId === itemId) {
        return { ...item, value: value };
      }
      return item;
    });
    setListItems(updatedItems);
  };
  
  
  const handleSubmit = async () => {
    await ClientService.insertClientQuestionnaire(
      selectedClientId,
      totalSum,
      [...listItems],
      questionId
    )
      .then((result) => {
        let questionList = result.resultData;
        navigate(APP_ROUTES.QUESTIONNAIRE);
        NotificationManager.success("Add successfully");
      })
      .catch((error) => {
        setLoading(false);
        renderErrors(error.message);
      });
  };

  // const arr = Object.entries(selectedValues).map(([key, value]) => {
  //   return { key: parseInt(key), value };
  // });

  const condition = "true";
  const condition2 = "1";
  const condition3 = "0"
  const condition4 = "false"
  const foundItem = listItems?.find((item) => item.value === condition || item.value === condition2  || item.value === condition3 || item.value === condition4);



  const handleSaveFromPortal = async () => {
    ClientQuestionnaireService.updatequestionnaireFromPortal(selectedClientId, totalSum, 
      [...listItems]
      , queId, token)
  }

  const handleCompleteFromPortal = async () => {
    try {
      ClientQuestionnaireService.completeQuestionnaireFromPortal(false, queId, selectedClientId, totalSum, 
        [...listItems]
        ,  {isCompleted: true, inProgress: false, sentToClientPortal: null}, token)
    } catch (error) {
      console.error('Error completing client questionnaire:', error);
      NotificationManager.error('Failed to complete client questionnaire');
    }
  };

  return (
    <div className="child_main_table mt-3 col-12">
      <div>
        <div className="head-4">COLUMBIA-SUICIDE SEVERITY RATING SCALE</div>
        <div className="head-6">Screen Version - Recent</div>
        <label className="pb-3 mt-2 border-bottom">
          SUICIDE IDEATION DEFINITIONS AND PROMPTS
        </label>
      </div>
  
      {(isPrint && (foundItem || listItems[listItems.length - 1]?.isSelected)) ? (
        <>
          {listItems.map((item) => {
            const isQ3 = item.questionId === "CSSRS_Q3";
            const isQ4 = item.questionId === "CSSRS_Q4";
            const isQ5 = item.questionId === "CSSRS_Q5";
            const isQ7 = item.questionId === "CSSRS_Q7";
            const applyPl2 = isQ3 || isQ4 || isQ5 || isQ7;
  
            return (
              <div className={`row mb-3 py-2 border-bottom ${applyPl2 ? 'pl-3' : ''}`} key={item.id}>
                <div className="col-12">
                  <label>
                    {item.id}. {item.name}
                  </label>
                </div>
                <div className="col-12 select_table_phq select-table-drops d-flex align-items-baseline gap-2">

                  <input 
                    type="radio"
                    name={`radio_${item.questionId}`}
                    value={true}
                    checked={
                      item?.type === "question" ? item.isSelected : item.value === "true"
                    }
                    onChange={() => handleRadioChange(item.questionId, "true")}
                    className="input_box_cats"
                  />
                  <label className="mr-3">Yes</label>
                  <input
                    type="radio"
                    name={`radio_${item.questionId}`}
                    value={false}
                    checked={
                      item?.type === "question"
                        ? item.isSelected === null
                          ? false
                          : !item.isSelected
                        : item.value === "false"
                    }
                    onChange={() => handleRadioChange(item.questionId, "false")}
                    className="input_box_cats"
                  />
                  <label className="mr-3">No</label>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        listItems.map((item) => {
          const isQ3 = item.questionId === "CSSRS_Q3";
          const isQ4 = item.questionId === "CSSRS_Q4";
          const isQ5 = item.questionId === "CSSRS_Q5";
          const isQ7 = item.questionId === "CSSRS_Q7";
          const applyPl2 = isQ3 || isQ4 || isQ5 || isQ7;
  
          return (
            <div className={`row mb-3 py-2 border-bottom ${applyPl2 ? 'pl-3' : ''}`} key={item.id}>
              {isQ3 && (
                <span>
                  <b>
                    If YES to 2, please answer questions 3, 4, 5, and 6. If NO to 2, go directly to question 6.
                  </b>
                </span>
              )}
              {isQ7 && (
                <span>
                  <b>If YES, please answer below given question</b>
                </span>
              )}
              <div className="col-12">
                <label>
                  {item.id}. {item.name}
                </label>
              </div>
  
              <div className="col-12 select_table_phq select-table-drops d-flex align-items-center">
                <div>
                  <input
                    type="radio"
                    name={`radio_${item.questionId}`}
                    value={true}
                    checked={
                      item?.type === "question" ? item.isSelected : item.value === "true"
                    }
                    onChange={() => handleRadioChange(item.questionId, "true")}
                    className="input_box_cats"
                  />
                  <label className="mr-3">Yes</label>
                  <input
                    type="radio"
                    name={`radio_${item.questionId}`}
                    value={false}
                    checked={
                      item?.type === "question"
                        ? item.isSelected === null
                          ? false
                          : !item.isSelected
                        : item.value === "false"
                    }
                    onChange={() => handleRadioChange(item.questionId, "false")}
                    className="input_box_cats"
                  />
                  <label className="mr-3">No</label>
                </div>
              </div>
            </div>
          );
        })
      )}
  
      {isFromCP ? (
        <div className="text-start mt-3 col-12">
          <button onClick={handleCompleteFromPortal} className="submitButon">
            Save & Complete
          </button>
          <button onClick={handleSaveFromPortal} className="cancelBtn">
            Save progress
          </button>
        </div>
      ) : state == null && !isPrint ? (
        <div className="text-start mt-3 col-12">
          <button onClick={handleSubmit} className="submitButon">
            Submit
          </button>
        </div>
      ) : null}
    </div>
  );
  
};

export default CSSRS;